import { sortArrayOfDates } from '../functions';

const initialContentState = {
  isFetching: true,
  contentPipeline: {},
  contentCountByType: {},
  pendingReviewByType: {},
  publishedByType: {},
  barChartLabels: [],
  donutChartLabels: [],
  radialChartLabels: [],
  barChartSeries: [{ data: [] }],
  allByMonthChartLabelsWithYears: [],
  allByMonthChartLabels: [],
  allByMonthChartSeries: [
    { name: 'Topics for Review', data: [] },
    { name: 'Writing', data: [] },
    { name: 'Hold', data: [] },
    { name: 'Writing (External Content)', data: [] },
    { name: 'Needs Edits (External Content)', data: [] },
    { name: 'QA', data: [] },
    { name: 'Content for Review', data: [] },
    { name: 'Revisions', data: [] },
    { name: 'Approved with Comments', data: [] },
    { name: 'Revised Content for Review', data: [] },
    { name: 'Publishing', data: [] },
    { name: 'Published', data: [] },
    { name: 'Residual Content', data: [] },
  ],
  donutChartSeries: [],
  radialChartSeries: [],
  assignPageFeature: {
    total: 0,
    rows: [],
    checked: {},
    checkedAll: false,
    areSelected: false,
    selectedAction: -1, // -1 - no action, 1 - approve, 2 - disapprove
    totalChecked: 0,
  },
  fullView: {
    currentPublishedDate: '',
    currentExpression: '',
    availableReviewers: [],
    isFetching: true,
    rows: [],
    unapprovedRows: [],
    currentPage: 1,
    perPage: 50,
    currentStatus: 'strategy',
    currentType: '',
    currentProdType: '',
    total: 0,
    availableTypes: [],
    checked: {},
    checkedAll: false,
    areSelected: false,
    selectedAction: -1, // -1 - no action, 1 - approve, 2 - disapprove
    totalChecked: 0,
  },
  clientNotesOpen: false,
  selectedClientNote: '',
};

const contentActions = {
  CONTENT_SET_ALL: 'CONTENT_SET_ALL',
  CONTENT_SET_IS_FETCHING: 'CONTENT_SET_IS_FETCHING',
  CONTENT_CLEAN: 'CONTENT_CLEAN',
  CONTENT_UPDATE_LEAD: 'CONTENT_UPDATE_LEAD',
  CONTENT_CHECK_BY_ID: 'CONTENT_CHECK_BY_ID',
  CONTENT_CHECK_ALL: 'CONTENT_CHECK_ALL',
  CONTENT_SET_REVIEWER: 'CONTENT_SET_REVIEWER',
  CONTENT_CHECK_BY_ID_ASSIGNED_PAGES: 'CONTENT_CHECK_BY_ID_ASSIGNED_PAGES',
  CONTENT_CHECK_ALL_ASSIGNED_PAGES: 'CONTENT_CHECK_ALL_ASSIGNED_PAGES',
  SET_CLIENT_NOTES_OPEN: 'SET_CLIENT_NOTES_OPEN',
  SET_SELECTED_CLIENT_NOTE: 'SET_SELECTED_CLIENT_NOTE',
};

function contentReducer(state, action) {
  const newState = state;
  switch (action.type) {
    case contentActions.CONTENT_SET_ALL:
      if (action.payload.allByMonth) {
        newState.allByMonthChartLabelsWithYears = [];
        newState.allByMonthChartLabels = [];
        newState.allByMonthChartSeries = [
          { name: 'Topics for Review', data: [] },
          { name: 'Writing', data: [] },
          { name: 'Hold', data: [] },
          { name: 'Writing (External Content)', data: [] },
          { name: 'QA', data: [] },
          { name: 'Content for Review', data: [] },
          { name: 'Revisions', data: [] },
          { name: 'Approved with Comments', data: [] },
          { name: 'Revised Content for Review', data: [] },
          { name: 'Publishing', data: [] },
          { name: 'Published', data: [] },
          { name: 'Residual Content', data: [] },
        ];
        const allByMonthLabels = sortArrayOfDates(Object.keys(action.payload.allByMonth), 'long');
        allByMonthLabels.forEach((key) => {
          newState.allByMonthChartLabelsWithYears.push(
            new Date(`01 ${key}`).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit'}).split('/').join('-')
          );
          newState.allByMonthChartLabels.push(
            new Date(`01 ${key}`).toLocaleString('en-US', { month: 'short' })
          );
          for (let key2 = 0; key2 < newState.allByMonthChartSeries.length; key2 += 1) {
            if (newState.allByMonthChartSeries[key2].name === 'Topics for Review') {
              newState.allByMonthChartSeries[key2].data.push(
                action.payload.allByMonth[key]['Topics for Review']
              );
            }
            if (newState.allByMonthChartSeries[key2].name === 'Writing') {
              newState.allByMonthChartSeries[key2].data.push(
                action.payload.allByMonth[key].Writing
              );
            }
            if (newState.allByMonthChartSeries[key2].name === 'Writing (External Content)') {
              newState.allByMonthChartSeries[key2].data.push(
                action.payload.allByMonth[key]['Writing (External Content)']
              );
            }
            if (newState.allByMonthChartSeries[key2].name === 'QA') {
              newState.allByMonthChartSeries[key2].data.push(
                action.payload.allByMonth[key].QA
              );
            }
            if (newState.allByMonthChartSeries[key2].name === 'Content for Review') {
              newState.allByMonthChartSeries[key2].data.push(
                action.payload.allByMonth[key]["Content for Review"]
              );
            }
            if (newState.allByMonthChartSeries[key2].name === 'Revisions') {
              newState.allByMonthChartSeries[key2].data.push(
                action.payload.allByMonth[key].Revisions
              );
            }
            if (newState.allByMonthChartSeries[key2].name === 'Approved with Comments') {
              newState.allByMonthChartSeries[key2].data.push(
                action.payload.allByMonth[key]["Approved with Comments"]
              );
            }
            if (newState.allByMonthChartSeries[key2].name === 'Revised Content for Review') {
              newState.allByMonthChartSeries[key2].data.push(
                action.payload.allByMonth[key]["Revised Content for Review"]
              );
            }
            if (newState.allByMonthChartSeries[key2].name === 'Publishing') {
              newState.allByMonthChartSeries[key2].data.push(
                action.payload.allByMonth[key].Publishing
              );
            }
            if (newState.allByMonthChartSeries[key2].name === 'Published') {
              newState.allByMonthChartSeries[key2].data.push(
                action.payload.allByMonth[key].Published
              );
            }
            if (newState.allByMonthChartSeries[key2].name === 'Hold') {
              newState.allByMonthChartSeries[key2].data.push(
                action.payload.allByMonth[key].Hold
              );
            }
            if (newState.allByMonthChartSeries[key2].name === 'Residual Content') {
              newState.allByMonthChartSeries[key2].data.push(
                action.payload.allByMonth[key]["Residual Content"]
              );
            }
          }
        });
      }
      if (action.payload.publishedByType) {
        newState.donutChartLabels = Object.keys(action.payload.publishedByType);
        newState.donutChartSeries = [];
        newState.donutChartLabels.forEach((key) => {
          newState.donutChartSeries.push(action.payload.publishedByType[key]);
        });
      }
      if (action.payload.pendingReviewByType) {
        newState.radialChartLabels = Object.keys(action.payload.pendingReviewByType);
        newState.radialChartSeries = [];
        newState.radialChartLabels.forEach((key) => {
          newState.radialChartSeries.push(action.payload.pendingReviewByType[key]);
        });
      }
      if (action.payload.contentPipeline) {
        newState.contentCountByType["Topics for Review"] = action.payload.contentPipeline["Topics for Review"];
        newState.contentCountByType.Writing = action.payload.contentPipeline.Writing;
        newState.contentCountByType['Writing (External Content)'] = action.payload.contentPipeline['Writing (External Content)'];
        newState.contentCountByType['Needs Edits (External Content)'] = action.payload.contentPipeline['Needs Edits (External Content)'];
        newState.contentCountByType.QA = action.payload.contentPipeline.QA;
        newState.contentCountByType["Content for Review"] = action.payload.contentPipeline["Content for Review"];
        newState.contentCountByType["Approved with Comments"] = action.payload.contentPipeline["Approved with Comments"];
        newState.contentCountByType.Revisions = action.payload.contentPipeline.Revisions;
        newState.contentCountByType["Revised Content for Review"] = action.payload.contentPipeline["Revised Content for Review"];
        newState.contentCountByType.Publishing = action.payload.contentPipeline.Publishing;
        newState.contentCountByType.Published = action.payload.contentPipeline.Published;
        newState.contentCountByType.Hold = action.payload.contentPipeline.Hold;
        newState.contentCountByType["Residual Content"] = action.payload.contentPipeline["Residual Content"];
      }
      if (
        state.fullView.currentStatus === 'topics_for_review' ||
        state.fullView.currentStatus === 'content_for_review' ||
        state.fullView.currentStatus === 'writing_external_content' || 
        state.fullView.currentStatus === 'needs_edits_external_content' ||
        state.fullView.currentStatus === 'revised_content_for_review'
      ) {
        if (action.payload.fullView) {
          if (action.payload.fullView.rows) {
            newState.fullView.checked = {};
            newState.fullView.checkedAll = false;
            newState.fullView.areSelected = false;
            newState.fullView.totalChecked = 0;
            newState.fullView.selectedAction = -1;
            action.payload.fullView.rows.forEach((row) => {
              newState.fullView.checked[row.id.toString()] = false;
            });
          }
        }
      }
      if (action.payload.assignPageFeature) {
        if (action.payload.assignPageFeature.rows) {
          newState.assignPageFeature.checked = {};
          newState.assignPageFeature.checkedAll = false;
          newState.assignPageFeature.areSelected = false;
          newState.assignPageFeature.totalChecked = 0;
          newState.assignPageFeature.selectedAction = -1;
          action.payload.assignPageFeature.rows.forEach((row) => {
            newState.assignPageFeature.checked[row.id.toString()] = false;
          });
        }
      }
      return {
        ...newState,
        ...action.payload,
        fullView: {
          ...newState.fullView,
          ...action.payload.fullView,
        },
        assignPageFeature: {
          ...newState.assignPageFeature,
          ...action.payload.assignPageFeature,
        },
      };
    case contentActions.CONTENT_CHECK_BY_ID:
      if (action.payload.checked && !newState.fullView.areSelected) {
        newState.fullView.areSelected = true;
      }
      if (action.payload.checked) {
        newState.fullView.totalChecked += 1;
      } else {
        newState.fullView.checkedAll = false;
        newState.fullView.totalChecked -= 1;
      }
      newState.fullView.checked[action.payload.id] = action.payload.checked;
      if (!action.payload.checked) {
        let areSelected = false;
        Object.values(newState.fullView.checked).forEach((val) => {
          if (val) {
            areSelected = true;
          }
        });
        newState.fullView.areSelected = areSelected;
      }
      return { ...newState };
    case contentActions.CONTENT_CHECK_ALL:
      if (action.payload.checked) {
        newState.fullView.totalChecked = Object.keys(newState.fullView.checked).length;
      } else {
        newState.fullView.totalChecked = 0;
      }
      newState.fullView.areSelected = !!action.payload.checked;
      Object.keys(newState.fullView.checked).forEach((key) => {
        newState.fullView.checked[key] = action.payload.checked;
      });
      newState.fullView.checkedAll = action.payload.checked;
      return {
        ...newState,
      };
    case contentActions.CONTENT_CHECK_BY_ID_ASSIGNED_PAGES:
      if (action.payload.checked && !newState.assignPageFeature.areSelected) {
        newState.assignPageFeature.areSelected = true;
      }
      if (action.payload.checked) {
        newState.assignPageFeature.totalChecked += 1;
      } else {
        newState.assignPageFeature.checkedAll = false;
        newState.assignPageFeature.totalChecked -= 1;
      }
      newState.assignPageFeature.checked[action.payload.id] = action.payload.checked;
      if (!action.payload.checked) {
        let areSelected = false;
        Object.values(newState.assignPageFeature.checked).forEach((val) => {
          if (val) {
            areSelected = true;
          }
        });
        newState.assignPageFeature.areSelected = areSelected;
      }
      return { ...newState };
    case contentActions.CONTENT_CHECK_ALL_ASSIGNED_PAGES:
      if (action.payload.checked) {
        newState.assignPageFeature.totalChecked = Object.keys(
          newState.assignPageFeature.checked
        ).length;
      } else {
        newState.assignPageFeature.totalChecked = 0;
      }
      newState.assignPageFeature.areSelected = !!action.payload.checked;
      Object.keys(newState.assignPageFeature.checked).forEach((key) => {
        newState.assignPageFeature.checked[key] = action.payload.checked;
      });
      newState.assignPageFeature.checkedAll = action.payload.checked;
      return {
        ...newState,
      };
    case contentActions.CONTENT_SET_IS_FETCHING:
      return { ...state, isFetching: action.payload.isFetching };
    case contentActions.CONTENT_CLEAN:
      return structuredClone(initialContentState);
    case contentActions.CONTENT_SET_REVIEWER:
      for (let i = 0; i < newState.fullView.rows.length; i += 1) {
        if (newState.fullView.rows[i].id === action.payload.pageId) {
          newState.fullView.rows[i].reviewer = action.payload.reviewer;
        }
      }
      return { ...newState };
    case contentActions.SET_CLIENT_NOTES_OPEN:
      return { ...state, clientNotesOpen: action.payload.clientNotesOpen };
    case contentActions.SET_SELECTED_CLIENT_NOTE:
      return { ...state, selectedClientNote: action.payload.selectedClientNote };
    default:
      return state;
  }
}

export { initialContentState, contentActions, contentReducer };
